import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        alignSelf: 'flex-start',
        paddingTop: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& + .MuiFormControlLabel-label': {
            paddingTop: 0,
        },
    },
    icon: {
        borderRadius: 2,
        width: 20,
        height: 20,
        border: `1px solid ${theme.palette.primary.light}`,
        backgroundColor: theme.palette.background.default,
        '$root.Mui-focusVisible &': {
            outline: `2px auto ${theme.palette.primary.light}`,
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
            borderColor: theme.palette.primary.light,
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: theme.palette.text.disabled,
        },
    },
    checkedIcon: {
        backgroundColor: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
        '&:before': {
            display: 'block',
            width: 20,
            height: 20,
            content: '""',
        },
        'input:hover ~ &': {
            //backgroundColor: theme.palette.primary.dark,
            backgroundColor: theme.palette.text.disabled,
        },
    },
    error: {
        color: theme.palette.error.main,
    },
    errorBorder: {
        borderColor: theme.palette.error.main,
    },
}));
